// extracted by mini-css-extract-plugin
module.exports = {"similarJobCard":"SimilarJobsSection_similarJobCard__t_bD9","heading":"SimilarJobsSection_heading__vcti3"};